import { createConfirmation } from "react-confirm";
import PracticeModal from "./PracticeModal";

export const showPracticeModal = createConfirmation(PracticeModal);
